import React from 'react'
import {
  CardContainer,
  ContentContainer,
  TitleContainer,
  Title,
  InfoContainer,
  InfoText,
  ActionButton
} from './styles'
import DebinIcon from 'assets/svg/DebinIcon'

const InfoCard: React.FC = () => {
  return (
    <CardContainer>
      <ContentContainer>
        <TitleContainer>
          <Title>Pagá con DEBIN</Title>
        </TitleContainer>

        <InfoContainer>
          <InfoText>
            Pagá desde tu cuenta bancaria en segundos.
            <br />
            Es seguro, inmediato y sin costos.
            {' '}
          </InfoText>
        </InfoContainer>

        <ActionButton>
          <DebinIcon color="#7D66FF" />
          Conocé más sobre pagos con DEBIN
        </ActionButton>
      </ContentContainer>
    </CardContainer>
  )
}

export default InfoCard
